export enum RequestInitTypeEnum {
	manual = 1,
	integration = 2,
	blockChain = 3
}
